export type Country = {
  countryNameLocal: string;
  countryName?: string;
  countrySynonymsLocal: string;
  countryCode: string;
  currencyCode: string;
  officialLanguageCode: string;
  phoneCode?: string;
  flag?: string;
  postalCode?: { mask: string; placeholder: string; regex: RegExp };
  phoneFormat?: {
    mask: string;
    placeholder: string;
    example: string;
    regex?: RegExp;
  };
  vatFormat?: {
    mask: string;
    placeholder: string;
    example: string;
    regex: RegExp;
  };
};

export const countries: Country[] = [
  {
    countryNameLocal: 'Andorra',
    countrySynonymsLocal: '',
    countryCode: 'AD',
    currencyCode: 'EUR',
    officialLanguageCode: 'ca',
    postalCode: { mask: 'aaaa999', placeholder: 'AD500', regex: /^AD\d{3}$/ }
  },
  {
    countryNameLocal:
      'د افغانستان اسلامي دولتدولت اسلامی افغانستان, جمهوری اسلامی افغانستان',
    countrySynonymsLocal: '',
    countryCode: 'AF',
    currencyCode: 'AFN',
    officialLanguageCode: 'fa'
  },
  {
    countryNameLocal: 'Antigua and Barbuda',
    countrySynonymsLocal: '',
    countryCode: 'AG',
    currencyCode: 'XCD',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'Anguilla',
    countrySynonymsLocal: '',
    countryCode: 'AI',
    currencyCode: 'XCD',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'Shqipëria',
    countrySynonymsLocal: '',
    countryCode: 'AL',
    currencyCode: 'ALL',
    officialLanguageCode: 'sq'
  },
  {
    countryNameLocal: 'Հայաստան',
    countrySynonymsLocal: '',
    countryCode: 'AM',
    currencyCode: 'AMD',
    officialLanguageCode: 'hy'
  },
  {
    countryNameLocal: 'Angola',
    countrySynonymsLocal: '',
    countryCode: 'AO',
    currencyCode: 'AOA',
    officialLanguageCode: 'pt'
  },
  {
    countryNameLocal: 'Antarctica, Antártico, Antarctique, Антарктике',
    countrySynonymsLocal: '',
    countryCode: 'AQ',
    currencyCode: '',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'Argentina',
    countrySynonymsLocal: '',
    countryCode: 'AR',
    currencyCode: 'ARS',
    officialLanguageCode: 'es',
    postalCode: {
      mask: 'a9999aaa',
      placeholder: 'C1234ABC',
      regex: /^[A-Z]\d{4}[A-Z]{3}$/
    }
  },
  {
    countryNameLocal: 'American Samoa',
    countrySynonymsLocal: '',
    countryCode: 'AS',
    currencyCode: 'USD',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'Österreich',
    countrySynonymsLocal: '',
    countryCode: 'AT',
    currencyCode: 'EUR',
    officialLanguageCode: 'de',
    countryName: 'Österreich',
    phoneCode: '+43',
    flag: '🇦🇹',
    postalCode: { mask: '9999', placeholder: '1234', regex: /^(\d{4})$/ },
    phoneFormat: {
      mask: '999 99999999',
      placeholder: '664 1234567',
      example: '+43 664 1234567',
      regex:
        /^(6[0-9]{2}|65[0-9]|66[0-9]|67[0-9]|68[0-9]|69[0-9]|2[0-9]{2}|3[0-9]{2}|4[0-9]{2}|5[0-9]{2}|7[0-9]{2}|8[0-9]{2}|9[0-9]{2})\s?[0-9]{6,7}$/
    },
    vatFormat: {
      mask: 'aa*99999999',
      placeholder: 'ATU12345678',
      example: 'ATU12345678',
      regex: /^AT[A-Z]\d{8}$/
    }
  },
  {
    countryNameLocal: 'Australia',
    countrySynonymsLocal: '',
    countryCode: 'AU',
    currencyCode: 'AUD',
    officialLanguageCode: 'en',
    countryName: 'Australien',
    phoneCode: '+61',
    flag: '🇦🇺',
    postalCode: { mask: '9999', placeholder: '2000', regex: /^\d{4}$/ },
    phoneFormat: {
      mask: '999 999 999',
      placeholder: '412 345 678',
      example: '+61 412 345 678'
    },
    vatFormat: {
      mask: '99 999 999 999',
      placeholder: '12 345 678 901',
      example: 'AU12 345 678 901',
      regex: /^\d{2} \d{3} \d{3} \d{3}$/
    }
  },
  {
    countryNameLocal: 'Aruba',
    countrySynonymsLocal: '',
    countryCode: 'AW',
    currencyCode: 'AWG',
    officialLanguageCode: 'nl'
  },
  {
    countryNameLocal: 'Åland',
    countrySynonymsLocal: '',
    countryCode: 'AX',
    currencyCode: 'EUR',
    officialLanguageCode: 'sv'
  },
  {
    countryNameLocal: 'Azərbaycan',
    countrySynonymsLocal: '',
    countryCode: 'AZ',
    currencyCode: 'AZN',
    officialLanguageCode: 'az'
  },
  {
    countryNameLocal: 'Bosna i Hercegovina',
    countrySynonymsLocal: '',
    countryCode: 'BA',
    currencyCode: 'BAM',
    officialLanguageCode: 'bs'
  },
  {
    countryNameLocal: 'Barbados',
    countrySynonymsLocal: '',
    countryCode: 'BB',
    currencyCode: 'BBD',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'গণপ্রজাতন্ত্রী বাংলাদেশ',
    countrySynonymsLocal: '',
    countryCode: 'BD',
    currencyCode: 'BDT',
    officialLanguageCode: 'bn'
  },
  {
    countryNameLocal: 'België, Belgique, Belgien',
    countrySynonymsLocal: '',
    countryCode: 'BE',
    currencyCode: 'EUR',
    officialLanguageCode: 'nl',
    countryName: 'Belgien',
    phoneCode: '+32',
    flag: '🇧🇪',
    postalCode: { mask: '9999', placeholder: '1234', regex: /^(\d{4})$/ },
    phoneFormat: {
      mask: '999 999999',
      placeholder: '496 123456',
      example: '+32 496 123456'
    },
    vatFormat: {
      mask: '9999999999',
      placeholder: '0123456789',
      example: 'BE0123456789',
      regex: /^\d{10}$/
    }
  },
  {
    countryNameLocal: 'Burkina Faso',
    countrySynonymsLocal: '',
    countryCode: 'BF',
    currencyCode: 'XOF',
    officialLanguageCode: 'fr'
  },
  {
    countryNameLocal: 'България',
    countrySynonymsLocal: '',
    countryCode: 'BG',
    currencyCode: 'BGN',
    officialLanguageCode: 'bg',
    countryName: 'Bulgarien',
    phoneCode: '+359',
    flag: '🇧🇬',
    postalCode: { mask: '9999', placeholder: '1234', regex: /^(\d{4})$/ },
    phoneFormat: {
      mask: '99 9999999',
      placeholder: '88 1234567',
      example: '+359 88 1234567'
    },
    vatFormat: {
      mask: '9999999999',
      placeholder: '123456789',
      example: 'BG123456789',
      regex: /^\d{9,10}$/
    }
  },
  {
    countryNameLocal: 'البحرين',
    countrySynonymsLocal: '',
    countryCode: 'BH',
    currencyCode: 'BHD',
    officialLanguageCode: 'ar'
  },
  {
    countryNameLocal: 'Burundi',
    countrySynonymsLocal: '',
    countryCode: 'BI',
    currencyCode: 'BIF',
    officialLanguageCode: 'fr'
  },
  {
    countryNameLocal: 'Bénin',
    countrySynonymsLocal: '',
    countryCode: 'BJ',
    currencyCode: 'XOF',
    officialLanguageCode: 'fr'
  },
  {
    countryNameLocal: 'Saint-Barthélemy',
    countrySynonymsLocal: '',
    countryCode: 'BL',
    currencyCode: 'EUR',
    officialLanguageCode: 'fr'
  },
  {
    countryNameLocal: 'Bermuda',
    countrySynonymsLocal: '',
    countryCode: 'BM',
    currencyCode: 'BMD',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'Brunei Darussalam',
    countrySynonymsLocal: '',
    countryCode: 'BN',
    currencyCode: 'BND',
    officialLanguageCode: 'ms',
    countryName: 'Brunei',
    phoneCode: '+673',
    flag: '🇧🇳',
    postalCode: {
      mask: 'aa9999',
      placeholder: 'AB1234',
      regex: /^[A-Z]{2}\d{4}$/
    },
    phoneFormat: {
      mask: '999 9999',
      placeholder: '712 3456',
      example: '+673 712 3456'
    },
    vatFormat: {
      mask: '99-9999999-999',
      placeholder: '12-3456789-012',
      example: 'BN12-3456789-012',
      regex: /^\d{2}-\d{7}-\d{3}$/
    }
  },
  {
    countryNameLocal: 'Bolivia, Bulibiya, Volívia, Wuliwya',
    countrySynonymsLocal: '',
    countryCode: 'BO',
    currencyCode: 'BOP',
    officialLanguageCode: 'es'
  },
  {
    countryNameLocal: 'Caribisch Nederland',
    countrySynonymsLocal: '',
    countryCode: 'BQ',
    currencyCode: 'USD',
    officialLanguageCode: 'nl'
  },
  {
    countryNameLocal: 'Brasil',
    countrySynonymsLocal: '',
    countryCode: 'BR',
    currencyCode: 'BRL',
    officialLanguageCode: 'pt',
    countryName: 'Brasilien',
    phoneCode: '+55',
    flag: '🇧🇷',
    postalCode: {
      mask: '99999-999',
      placeholder: '12345-678',
      regex: /^\d{5}-\d{3}$/
    },
    phoneFormat: {
      mask: '(99) 99999-9999',
      placeholder: '(11) 91234-5678',
      example: '+55 (11) 91234-5678'
    },
    vatFormat: {
      mask: '99.999.999/9999-99',
      placeholder: '12.345.678/0001-90',
      example: 'BR12.345.678/0001-90',
      regex: /^\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}$/
    }
  },
  {
    countryNameLocal: 'འབྲུག་ཡུལ',
    countrySynonymsLocal: '',
    countryCode: 'BT',
    currencyCode: 'BTN',
    officialLanguageCode: 'dz'
  },
  {
    countryNameLocal: 'Bouvetøya',
    countrySynonymsLocal: '',
    countryCode: 'BV',
    currencyCode: 'NOK',
    officialLanguageCode: 'no'
  },
  {
    countryNameLocal: 'Botswana',
    countrySynonymsLocal: '',
    countryCode: 'BW',
    currencyCode: 'BWP',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'Беларусь',
    countrySynonymsLocal: '',
    countryCode: 'BY',
    currencyCode: 'BYR',
    officialLanguageCode: 'be'
  },
  {
    countryNameLocal: 'Belize',
    countrySynonymsLocal: '',
    countryCode: 'BZ',
    currencyCode: 'BZD',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'Canada',
    countrySynonymsLocal: '',
    countryCode: 'CA',
    currencyCode: 'CAD',
    officialLanguageCode: 'en',
    countryName: 'Kanada',
    phoneCode: '+1',
    flag: '🇨🇦',
    postalCode: {
      mask: 'a9a 9a9',
      placeholder: 'G5Y 8J8',
      regex: /^[A-Z]\d[A-Z] \d[A-Z]\d$/
    },
    phoneFormat: {
      mask: '(999) 999-9999',
      placeholder: '(416) 123-4567',
      example: '+1 (416) 123-4567'
    },
    vatFormat: {
      mask: '999999999**9999',
      placeholder: '123456789RT0001',
      example: 'CA123456789RT0001',
      regex: /^\d{9}(RT|RM|RP)\d{4}$/
    }
  },
  {
    countryNameLocal: 'Schweiz, Suisse, Svizzera, Svizra',
    countrySynonymsLocal: '',
    countryCode: 'CH',
    currencyCode: 'CHE',
    officialLanguageCode: 'de',
    countryName: 'Schweiz',
    phoneCode: '+41',
    flag: '🇨🇭',
    postalCode: { mask: '9999', placeholder: '1234', regex: /^(\d{4})$/ },
    phoneFormat: {
      mask: '99 999 99 99',
      placeholder: '79 123 45 67',
      example: '+41 79 123 45 67'
    },
    vatFormat: {
      mask: '999999',
      placeholder: '123456',
      example: 'CHE-123.456.789 MWST',
      regex: /^\d{6}$/
    }
  },
  {
    countryNameLocal: "Côte d'Ivoire",
    countrySynonymsLocal: '',
    countryCode: 'CI',
    currencyCode: 'XOF',
    officialLanguageCode: 'fr'
  },
  {
    countryNameLocal: 'Chile',
    countrySynonymsLocal: '',
    countryCode: 'CL',
    currencyCode: 'CLP',
    officialLanguageCode: 'es'
  },
  {
    countryNameLocal: 'Cameroun, Cameroon',
    countrySynonymsLocal: '',
    countryCode: 'CM',
    currencyCode: 'XAF',
    officialLanguageCode: 'fr'
  },
  {
    countryNameLocal: '中国',
    countrySynonymsLocal: '',
    countryCode: 'CN',
    currencyCode: 'CNY',
    officialLanguageCode: 'zh-hans',
    countryName: 'China',
    phoneCode: '+86',
    flag: '🇨🇳',
    postalCode: { mask: '999999', placeholder: '123456', regex: /^\d{6}$/ },
    phoneFormat: {
      mask: '999 9999 9999',
      placeholder: '138 0013 8000',
      example: '+86 138 0013 8000'
    },
    vatFormat: {
      mask: '999999999999999999',
      placeholder: '123456789012345678',
      example: 'CN123456789012345678',
      regex: /^\d{18}$/
    }
  },
  {
    countryNameLocal: 'Colombia',
    countrySynonymsLocal: '',
    countryCode: 'CO',
    currencyCode: 'COP',
    officialLanguageCode: 'es'
  },
  {
    countryNameLocal: 'Costa Rica',
    countrySynonymsLocal: '',
    countryCode: 'CR',
    currencyCode: 'CRC',
    officialLanguageCode: 'es'
  },
  {
    countryNameLocal: 'Cuba',
    countrySynonymsLocal: '',
    countryCode: 'CU',
    currencyCode: 'CUC',
    officialLanguageCode: 'es'
  },
  {
    countryNameLocal: 'Cabo Verde',
    countrySynonymsLocal: '',
    countryCode: 'CV',
    currencyCode: 'CVE',
    officialLanguageCode: 'pt'
  },
  {
    countryNameLocal: 'Curaçao',
    countrySynonymsLocal: '',
    countryCode: 'CW',
    currencyCode: 'ANG',
    officialLanguageCode: 'nl'
  },
  {
    countryNameLocal: 'Christmas Island',
    countrySynonymsLocal: '',
    countryCode: 'CX',
    currencyCode: 'AUD',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'Κύπρος, Kibris',
    countrySynonymsLocal: '',
    countryCode: 'CY',
    currencyCode: 'EUR',
    officialLanguageCode: 'el'
  },
  {
    countryNameLocal: 'Deutschland',
    countrySynonymsLocal: '',
    countryCode: 'DE',
    currencyCode: 'EUR',
    officialLanguageCode: 'de',
    countryName: 'Deutschland',
    phoneCode: '+49',
    flag: '🇩🇪',
    postalCode: { mask: '99999', placeholder: '12345', regex: /^(\d{5})$/ },
    phoneFormat: {
      mask: '999 99999999',
      placeholder: '151 12345678',
      example: '+49 151 12345678'
    },
    vatFormat: {
      mask: 'aa 999999999',
      placeholder: 'DE123456789',
      example: 'DE123456789',
      regex: /^DE\d{9}$/
    }
  },
  {
    countryNameLocal: 'Djibouti, جيبوتي, Jabuuti, Gabuutih',
    countrySynonymsLocal: '',
    countryCode: 'DJ',
    currencyCode: 'DJF',
    officialLanguageCode: 'fr'
  },
  {
    countryNameLocal: 'Danmark',
    countrySynonymsLocal: '',
    countryCode: 'DK',
    currencyCode: 'DKK',
    officialLanguageCode: 'da',
    countryName: 'Dänemark',
    phoneCode: '+45',
    flag: '🇩🇰',
    postalCode: { mask: '9999', placeholder: '1234', regex: /^(\d{4})$/ },
    phoneFormat: {
      mask: '99 99 99 99',
      placeholder: '20 12 34 56',
      example: '+45 20 12 34 56'
    },
    vatFormat: {
      mask: '99999999',
      placeholder: '12345678',
      example: 'DK12345678',
      regex: /^\d{8}$/
    }
  },
  {
    countryNameLocal: 'Dominica',
    countrySynonymsLocal: '',
    countryCode: 'DM',
    currencyCode: 'XCD',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'الجزائر',
    countrySynonymsLocal: '',
    countryCode: 'DZ',
    currencyCode: 'DZD',
    officialLanguageCode: 'ar'
  },
  {
    countryNameLocal: 'Ecuador',
    countrySynonymsLocal: '',
    countryCode: 'EC',
    currencyCode: 'USD',
    officialLanguageCode: 'es'
  },
  {
    countryNameLocal: 'Eesti',
    countrySynonymsLocal: '',
    countryCode: 'EE',
    currencyCode: 'EUR',
    officialLanguageCode: 'et',
    countryName: 'Estland',
    phoneCode: '+372',
    flag: '🇪🇪',
    postalCode: { mask: '99999', placeholder: '12345', regex: /^(\d{5})$/ },
    phoneFormat: {
      mask: '9999 9999',
      placeholder: '5123 4567',
      example: '+372 5123 4567'
    },
    vatFormat: {
      mask: '999999999',
      placeholder: '123456789',
      example: 'EE123456789',
      regex: /^\d{9}$/
    }
  },
  {
    countryNameLocal: 'مصر',
    countrySynonymsLocal: '',
    countryCode: 'EG',
    currencyCode: 'EGP',
    officialLanguageCode: 'ar'
  },
  {
    countryNameLocal: 'Sahara Occidental',
    countrySynonymsLocal: '',
    countryCode: 'EH',
    currencyCode: 'MAD',
    officialLanguageCode: 'ar'
  },
  {
    countryNameLocal: 'ኤርትራ, إرتريا, Eritrea',
    countrySynonymsLocal: '',
    countryCode: 'ER',
    currencyCode: 'ERN',
    officialLanguageCode: 'ti'
  },
  {
    countryNameLocal: 'España',
    countrySynonymsLocal: '',
    countryCode: 'ES',
    currencyCode: 'EUR',
    officialLanguageCode: 'es',
    countryName: 'Spanien',
    phoneCode: '+34',
    flag: '🇪🇸',
    postalCode: { mask: '99999', placeholder: '12345', regex: /^(\d{5})$/ },
    phoneFormat: {
      mask: '999 999 999',
      placeholder: '612 345 678',
      example: '+34 612 345 678'
    },
    vatFormat: {
      mask: '*99999999*',
      placeholder: 'A12345674',
      example: 'ESA12345674',
      regex: /^[A-Z]\d{7}[A-Z0-9]$/
    }
  },
  {
    countryNameLocal: 'ኢትዮጵያ, Itoophiyaa',
    countrySynonymsLocal: '',
    countryCode: 'ET',
    currencyCode: 'ETB',
    officialLanguageCode: 'am'
  },
  {
    countryNameLocal: 'Suomi',
    countrySynonymsLocal: '',
    countryCode: 'FI',
    currencyCode: 'EUR',
    officialLanguageCode: 'fi',
    countryName: 'Finnland',
    phoneCode: '+358',
    flag: '🇫🇮',
    postalCode: { mask: '99999', placeholder: '12345', regex: /^(\d{5})$/ },
    phoneFormat: {
      mask: '99 9999999',
      placeholder: '40 1234567',
      example: '+358 40 1234567'
    },
    vatFormat: {
      mask: '99999999',
      placeholder: '12345678',
      example: 'FI12345678',
      regex: /^\d{8}$/
    }
  },
  {
    countryNameLocal: 'Fiji',
    countrySynonymsLocal: '',
    countryCode: 'FJ',
    currencyCode: 'FJD',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'Micronesia',
    countrySynonymsLocal: '',
    countryCode: 'FM',
    currencyCode: 'USD',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'France',
    countrySynonymsLocal: '',
    countryCode: 'FR',
    currencyCode: 'EUR',
    officialLanguageCode: 'fr',
    countryName: 'Frankreich',
    phoneCode: '+33',
    flag: '🇫🇷',
    postalCode: { mask: '99999', placeholder: '12345', regex: /^(\d{5})$/ },
    phoneFormat: {
      mask: '9 99 99 99 99',
      placeholder: '6 12 34 56 78',
      example: '+33 6 12 34 56 78'
    },
    vatFormat: {
      mask: '*99999999999',
      placeholder: 'FR12345678901',
      example: 'FR12345678901',
      regex: /^FR[A-Z0-9]{2}\d{9}$/
    }
  },
  {
    countryNameLocal: 'Gabon',
    countrySynonymsLocal: '',
    countryCode: 'GA',
    currencyCode: 'XAF',
    officialLanguageCode: 'fr'
  },
  {
    countryNameLocal: 'Grenada',
    countrySynonymsLocal: '',
    countryCode: 'GD',
    currencyCode: 'XCD',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'საქართველო',
    countrySynonymsLocal: '',
    countryCode: 'GE',
    currencyCode: 'GEL',
    officialLanguageCode: 'ka'
  },
  {
    countryNameLocal: 'Guyane française',
    countrySynonymsLocal: '',
    countryCode: 'GF',
    currencyCode: 'EUR',
    officialLanguageCode: 'fr'
  },
  {
    countryNameLocal: 'Guernsey',
    countrySynonymsLocal: '',
    countryCode: 'GG',
    currencyCode: 'GBP',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'Ghana',
    countrySynonymsLocal: '',
    countryCode: 'GH',
    currencyCode: 'GHS',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'Gibraltar',
    countrySynonymsLocal: '',
    countryCode: 'GI',
    currencyCode: 'GIP',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'Kalaallit Nunaat, Grønland',
    countrySynonymsLocal: '',
    countryCode: 'GL',
    currencyCode: 'DKK',
    officialLanguageCode: 'kl'
  },
  {
    countryNameLocal: 'Guinée',
    countrySynonymsLocal: '',
    countryCode: 'GN',
    currencyCode: 'GNF',
    officialLanguageCode: 'fr'
  },
  {
    countryNameLocal: 'Guadeloupe',
    countrySynonymsLocal: '',
    countryCode: 'GP',
    currencyCode: 'EUR',
    officialLanguageCode: 'fr'
  },
  {
    countryNameLocal: 'Guiena ecuatorial, Guinée équatoriale, Guiné Equatorial',
    countrySynonymsLocal: '',
    countryCode: 'GQ',
    currencyCode: 'XAF',
    officialLanguageCode: 'es'
  },
  {
    countryNameLocal: 'Ελλάδα',
    countrySynonymsLocal: '',
    countryCode: 'GR',
    currencyCode: 'EUR',
    officialLanguageCode: 'el',
    countryName: 'Griechenland',
    phoneCode: '+30',
    flag: '🇬🇷',
    postalCode: {
      mask: '999 99',
      placeholder: '123 45',
      regex: /^(\d{3} \d{2})$/
    },
    phoneFormat: {
      mask: '999 9999999',
      placeholder: '694 1234567',
      example: '+30 694 1234567'
    },
    vatFormat: {
      mask: '999999999',
      placeholder: '123456789',
      example: 'EL123456789',
      regex: /^\d{9}$/
    }
  },
  {
    countryNameLocal: 'South Georgia and the South Sandwich Islands',
    countrySynonymsLocal: '',
    countryCode: 'GS',
    currencyCode: '',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'Guatemala',
    countrySynonymsLocal: '',
    countryCode: 'GT',
    currencyCode: 'GTQ',
    officialLanguageCode: 'es'
  },
  {
    countryNameLocal: 'Guam, Guåhån',
    countrySynonymsLocal: '',
    countryCode: 'GU',
    currencyCode: 'USD',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'Guiné-Bissau',
    countrySynonymsLocal: '',
    countryCode: 'GW',
    currencyCode: 'XOF',
    officialLanguageCode: 'pt'
  },
  {
    countryNameLocal: 'Guyana',
    countrySynonymsLocal: '',
    countryCode: 'GY',
    currencyCode: 'GYD',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: '香港, Hong Kong',
    countrySynonymsLocal: '',
    countryCode: 'HK',
    currencyCode: 'HKD',
    officialLanguageCode: 'zh-hant'
  },
  {
    countryNameLocal: 'Honduras',
    countrySynonymsLocal: '',
    countryCode: 'HN',
    currencyCode: 'HNL',
    officialLanguageCode: 'es',
    countryName: 'Honduras',
    phoneCode: '+504',
    flag: '🇭🇳',
    postalCode: {
      mask: 'aa9999',
      placeholder: 'AB1234',
      regex: /^[A-Z]{2}\d{4}$/
    },
    phoneFormat: {
      mask: '9999-9999',
      placeholder: '9123-4567',
      example: '+504 9123-4567'
    },
    vatFormat: {
      mask: '99999999999999',
      placeholder: '12345678901234',
      example: 'HN12345678901234',
      regex: /^\d{14}$/
    }
  },
  {
    countryNameLocal: 'Hrvatska',
    countrySynonymsLocal: '',
    countryCode: 'HR',
    currencyCode: 'HRK',
    officialLanguageCode: 'hr',
    countryName: 'Kroatien',
    phoneCode: '+385',
    flag: '🇭🇷',
    postalCode: { mask: '99999', placeholder: '12345', regex: /^(\d{5})$/ },
    phoneFormat: {
      mask: '99 9999999',
      placeholder: '91 1234567',
      example: '+385 91 1234567'
    },
    vatFormat: {
      mask: '99999999999',
      placeholder: '12345678901',
      example: 'HR12345678901',
      regex: /^\d{11}$/
    }
  },
  {
    countryNameLocal: 'Haïti, Ayiti',
    countrySynonymsLocal: '',
    countryCode: 'HT',
    currencyCode: 'HTG',
    officialLanguageCode: 'fr'
  },
  {
    countryNameLocal: 'Magyarország',
    countrySynonymsLocal: '',
    countryCode: 'HU',
    currencyCode: 'HUF',
    officialLanguageCode: 'hu',
    countryName: 'Ungarn',
    phoneCode: '+36',
    flag: '🇭🇺',
    postalCode: { mask: '9999', placeholder: '1234', regex: /^(\d{4})$/ },
    phoneFormat: {
      mask: '99 9999999',
      placeholder: '20 1234567',
      example: '+36 20 1234567'
    },
    vatFormat: {
      mask: '99999999',
      placeholder: '12345678',
      example: 'HU12345678',
      regex: /^\d{8}$/
    }
  },
  {
    countryNameLocal: 'Indonesia',
    countrySynonymsLocal: '',
    countryCode: 'ID',
    currencyCode: 'IDR',
    officialLanguageCode: 'id',
    countryName: 'Indonesien',
    phoneCode: '+62',
    flag: '🇮🇩',
    postalCode: { mask: '99999', placeholder: '12345', regex: /^\d{5}$/ },
    phoneFormat: {
      mask: '999-9999-9999',
      placeholder: '812-3456-7890',
      example: '+62 812-3456-7890'
    },
    vatFormat: {
      mask: '999.999.999-999.999',
      placeholder: '123.456.789-012.345',
      example: 'ID123.456.789-012.345',
      regex: /^\d{3}\.\d{3}\.\d{3}-\d{3}\.\d{3}$/
    }
  },
  {
    countryNameLocal: 'Ireland, Éire',
    countrySynonymsLocal: '',
    countryCode: 'IE',
    currencyCode: 'EUR',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'ישראל',
    countrySynonymsLocal: '',
    countryCode: 'IL',
    currencyCode: 'ILS',
    officialLanguageCode: 'he'
  },
  {
    countryNameLocal: 'Isle of Man',
    countrySynonymsLocal: '',
    countryCode: 'IM',
    currencyCode: 'GBP',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'भारत, India',
    countrySynonymsLocal: '',
    countryCode: 'IN',
    currencyCode: 'INR',
    officialLanguageCode: 'hi',
    countryName: 'Indien',
    phoneCode: '+91',
    flag: '🇮🇳',
    postalCode: { mask: '999999', placeholder: '123456', regex: /^\d{6}$/ },
    phoneFormat: {
      mask: '99999 99999',
      placeholder: '98765 43210',
      example: '+91 98765 43210'
    },
    vatFormat: {
      mask: '99aaaaaa999a9aa',
      placeholder: '12ABCDE3456F1Z5',
      example: 'IN12ABCDE3456F1Z5',
      regex: /^\d{2}[A-Z]{5}\d{4}[A-Z][A-Z0-9][Z][A-Z0-9]$/
    }
  },
  {
    countryNameLocal: 'British Indian Ocean Territories',
    countrySynonymsLocal: '',
    countryCode: 'IO',
    currencyCode: 'USD',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'العراق, Iraq',
    countrySynonymsLocal: '',
    countryCode: 'IQ',
    currencyCode: 'IQD',
    officialLanguageCode: 'ar'
  },
  {
    countryNameLocal: 'ایران',
    countrySynonymsLocal: '',
    countryCode: 'IR',
    currencyCode: 'IRR',
    officialLanguageCode: 'fa'
  },
  {
    countryNameLocal: 'Ísland',
    countrySynonymsLocal: '',
    countryCode: 'IS',
    currencyCode: 'ISK',
    officialLanguageCode: 'is'
  },
  {
    countryNameLocal: 'Italia',
    countrySynonymsLocal: '',
    countryCode: 'IT',
    currencyCode: 'EUR',
    officialLanguageCode: 'it',
    countryName: 'Italien',
    phoneCode: '+39',
    flag: '🇮🇹',
    postalCode: { mask: '99999', placeholder: '12345', regex: /^(\d{5})$/ },
    phoneFormat: {
      mask: '999 9999999',
      placeholder: '333 1234567',
      example: '+39 333 1234567'
    },
    vatFormat: {
      mask: '99999999999',
      placeholder: '12345678901',
      example: 'IT12345678901',
      regex: /^\d{11}$/
    }
  },
  {
    countryNameLocal: 'Jersey',
    countrySynonymsLocal: '',
    countryCode: 'JE',
    currencyCode: 'GBP',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'Jamaica',
    countrySynonymsLocal: '',
    countryCode: 'JM',
    currencyCode: 'JMD',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'الأُرْدُن',
    countrySynonymsLocal: '',
    countryCode: 'JO',
    currencyCode: 'JOD',
    officialLanguageCode: 'ar'
  },
  {
    countryNameLocal: '日本',
    countrySynonymsLocal: '',
    countryCode: 'JP',
    currencyCode: 'JPY',
    officialLanguageCode: 'ja',
    countryName: 'Japan',
    phoneCode: '+81',
    flag: '🇯🇵',
    postalCode: {
      mask: '999-9999',
      placeholder: '105-0002',
      regex: /^\d{3}-\d{4}$/
    },
    phoneFormat: {
      mask: '99-9999-9999',
      placeholder: '90-1234-5678',
      example: '+81 90-1234-5678'
    },
    vatFormat: {
      mask: '9999999999999',
      placeholder: '1234567890123',
      example: 'JP1234567890123',
      regex: /^\d{13}$/
    }
  },
  {
    countryNameLocal: 'Kenya',
    countrySynonymsLocal: '',
    countryCode: 'KE',
    currencyCode: 'KES',
    officialLanguageCode: 'sw'
  },
  {
    countryNameLocal: 'Кыргызстан, Киргизия',
    countrySynonymsLocal: '',
    countryCode: 'KG',
    currencyCode: 'KGS',
    officialLanguageCode: 'ky'
  },
  {
    countryNameLocal: 'កម្ពុជា',
    countrySynonymsLocal: '',
    countryCode: 'KH',
    currencyCode: 'KHR',
    officialLanguageCode: 'km'
  },
  {
    countryNameLocal: '대한민국',
    countrySynonymsLocal: '',
    countryCode: 'KR',
    currencyCode: 'KRW',
    officialLanguageCode: 'ko',
    countryName: 'Korea',
    phoneCode: '+82',
    flag: '🇰🇷',
    postalCode: { mask: '99999', placeholder: '12345', regex: /^\d{5}$/ },
    phoneFormat: {
      mask: '99-9999-9999',
      placeholder: '10-1234-5678',
      example: '+82 10-1234-5678'
    },
    vatFormat: {
      mask: '999-99-99999',
      placeholder: '123-45-67890',
      example: 'KR123-45-67890',
      regex: /^\d{3}-\d{2}-\d{5}$/
    }
  },
  {
    countryNameLocal: 'Kiribati',
    countrySynonymsLocal: '',
    countryCode: 'KI',
    currencyCode: 'AUD',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'Saint Kitts and Nevis',
    countrySynonymsLocal: '',
    countryCode: 'KN',
    currencyCode: 'XCD',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'الكويت',
    countrySynonymsLocal: '',
    countryCode: 'KW',
    currencyCode: 'KWD',
    officialLanguageCode: 'ar'
  },
  {
    countryNameLocal: 'Қазақстан, Казахстан',
    countrySynonymsLocal: '',
    countryCode: 'KZ',
    currencyCode: 'KZT',
    officialLanguageCode: 'kk'
  },
  {
    countryNameLocal: 'لبنان, Liban',
    countrySynonymsLocal: '',
    countryCode: 'LB',
    currencyCode: 'LBP',
    officialLanguageCode: 'ar'
  },
  {
    countryNameLocal: 'Saint Lucia',
    countrySynonymsLocal: '',
    countryCode: 'LC',
    currencyCode: 'XCD',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'Liechtenstein',
    countrySynonymsLocal: '',
    countryCode: 'LI',
    currencyCode: 'CHF',
    officialLanguageCode: 'de'
  },
  {
    countryNameLocal: 'ශ්‍රී ලංකා, இலங்கை',
    countrySynonymsLocal: '',
    countryCode: 'LK',
    currencyCode: 'LKR',
    officialLanguageCode: 'si'
  },
  {
    countryNameLocal: 'Liberia',
    countrySynonymsLocal: '',
    countryCode: 'LR',
    currencyCode: 'LRD',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'Lesotho',
    countrySynonymsLocal: '',
    countryCode: 'LS',
    currencyCode: 'LSL',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'Lietuva',
    countrySynonymsLocal: '',
    countryCode: 'LT',
    currencyCode: 'EUR',
    officialLanguageCode: 'lt',
    countryName: 'Litauen',
    phoneCode: '+370',
    flag: '🇱🇹',
    postalCode: { mask: '99999', placeholder: '12345', regex: /^(\d{5})$/ },
    phoneFormat: {
      mask: '999 99999',
      placeholder: '612 34567',
      example: '+370 612 34567'
    },
    vatFormat: {
      mask: '999999999999',
      placeholder: '123456789',
      example: 'LT123456789',
      regex: /^\d{9}|\d{12}$/
    }
  },
  {
    countryNameLocal: 'Lëtzebuerg, Luxembourg, Luxemburg',
    countrySynonymsLocal: '',
    countryCode: 'LU',
    currencyCode: 'EUR',
    officialLanguageCode: 'lb',
    countryName: 'Luxemburg',
    phoneCode: '+352',
    flag: '🇱🇺',
    postalCode: { mask: '9999', placeholder: '1234', regex: /^(\d{4})$/ },
    phoneFormat: {
      mask: '999 999 999',
      placeholder: '691 123 456',
      example: '+352 691 123 456'
    },
    vatFormat: {
      mask: '99999999',
      placeholder: '12345678',
      example: 'LU12345678',
      regex: /^\d{8}$/
    }
  },
  {
    countryNameLocal: 'Latvija',
    countrySynonymsLocal: '',
    countryCode: 'LV',
    currencyCode: 'EUR',
    officialLanguageCode: 'lv',
    countryName: 'Lettland',
    phoneCode: '+371',
    flag: '🇱🇻',
    postalCode: { mask: '9999', placeholder: '1234', regex: /^(\d{4})$/ },
    phoneFormat: {
      mask: '99999999',
      placeholder: '21234567',
      example: '+371 21234567'
    },
    vatFormat: {
      mask: '99999999999',
      placeholder: '12345678901',
      example: 'LV12345678901',
      regex: /^\d{11}$/
    }
  },
  {
    countryNameLocal: 'ليبيا',
    countrySynonymsLocal: '',
    countryCode: 'LY',
    currencyCode: 'LYD',
    officialLanguageCode: 'ar'
  },
  {
    countryNameLocal: 'Maroc, ⵍⵎⵖⵔⵉⴱ, المغرب',
    countrySynonymsLocal: '',
    countryCode: 'MA',
    currencyCode: 'MAD',
    officialLanguageCode: 'fr'
  },
  {
    countryNameLocal: 'Monaco',
    countrySynonymsLocal: '',
    countryCode: 'MC',
    currencyCode: 'EUR',
    officialLanguageCode: 'fr'
  },
  {
    countryNameLocal: 'Crna Gora, Црна Гора',
    countrySynonymsLocal: '',
    countryCode: 'ME',
    currencyCode: 'EUR',
    officialLanguageCode: 'srp'
  },
  {
    countryNameLocal: 'Saint-Martin',
    countrySynonymsLocal: '',
    countryCode: 'MF',
    currencyCode: 'EUR',
    officialLanguageCode: 'fr'
  },
  {
    countryNameLocal: 'Madagasikara, Madagascar',
    countrySynonymsLocal: '',
    countryCode: 'MG',
    currencyCode: 'MGA',
    officialLanguageCode: 'mg'
  },
  {
    countryNameLocal: 'Mali',
    countrySynonymsLocal: '',
    countryCode: 'ML',
    currencyCode: 'XOF',
    officialLanguageCode: 'fr'
  },
  {
    countryNameLocal: 'မြန်မာ',
    countrySynonymsLocal: '',
    countryCode: 'MM',
    currencyCode: 'MMK',
    officialLanguageCode: 'my'
  },
  {
    countryNameLocal: 'Монгол Улс',
    countrySynonymsLocal: '',
    countryCode: 'MN',
    currencyCode: 'MNT',
    officialLanguageCode: 'mn'
  },
  {
    countryNameLocal: '澳門, Macau',
    countrySynonymsLocal: '',
    countryCode: 'MO',
    currencyCode: 'MOP',
    officialLanguageCode: 'zh-hant'
  },
  {
    countryNameLocal: 'Martinique',
    countrySynonymsLocal: '',
    countryCode: 'MQ',
    currencyCode: 'EUR',
    officialLanguageCode: 'fr'
  },
  {
    countryNameLocal: 'موريتانيا, Mauritanie',
    countrySynonymsLocal: '',
    countryCode: 'MR',
    currencyCode: 'MRU',
    officialLanguageCode: 'ar'
  },
  {
    countryNameLocal: 'Montserrat',
    countrySynonymsLocal: '',
    countryCode: 'MS',
    currencyCode: 'XCD',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'Malta',
    countrySynonymsLocal: '',
    countryCode: 'MT',
    currencyCode: 'EUR',
    officialLanguageCode: 'mt',
    countryName: 'Malta',
    phoneCode: '+356',
    flag: '🇲🇹',
    postalCode: {
      mask: 'aaa 9999',
      placeholder: 'ABC 1234',
      regex: /^[A-Z]{3} [0-9]{4}$/
    },
    phoneFormat: {
      mask: '9999 9999',
      placeholder: '9912 3456',
      example: '+356 9912 3456'
    },
    vatFormat: {
      mask: '99999999',
      placeholder: '12345678',
      example: 'MT12345678',
      regex: /^\d{8}$/
    }
  },
  {
    countryNameLocal: 'Maurice, Mauritius',
    countrySynonymsLocal: '',
    countryCode: 'MU',
    currencyCode: 'MUR',
    officialLanguageCode: 'mfe',
    countryName: 'Mauritius',
    phoneCode: '+230',
    flag: '🇲🇺',
    postalCode: { mask: '99999', placeholder: '12345', regex: /^\d{5}$/ },
    phoneFormat: {
      mask: '9999 9999',
      placeholder: '5123 4567',
      example: '+230 5123 4567'
    },
    vatFormat: {
      mask: '99999999',
      placeholder: '12345678',
      example: 'MU12345678',
      regex: /^\d{8}$/
    }
  },
  {
    countryNameLocal: '',
    countrySynonymsLocal: '',
    countryCode: 'MV',
    currencyCode: 'MVR',
    officialLanguageCode: 'dv'
  },
  {
    countryNameLocal: 'Malawi',
    countrySynonymsLocal: '',
    countryCode: 'MW',
    currencyCode: 'MWK',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'México',
    countrySynonymsLocal: '',
    countryCode: 'MX',
    currencyCode: 'MXN',
    officialLanguageCode: 'es'
  },
  {
    countryNameLocal: '',
    countrySynonymsLocal: '',
    countryCode: 'MY',
    currencyCode: 'MYR',
    officialLanguageCode: 'ms',
    countryName: 'Malaysia',
    phoneCode: '+60',
    flag: '🇲🇾',
    postalCode: { mask: '99999', placeholder: '12345', regex: /^\d{5}$/ },
    phoneFormat: {
      mask: '99-999 9999',
      placeholder: '12-345 6789',
      example: '+60 12-345 6789'
    },
    vatFormat: {
      mask: '999999999999',
      placeholder: '123456789012',
      example: 'MY123456789012',
      regex: /^\d{12}$/
    }
  },
  {
    countryNameLocal: 'Mozambique',
    countrySynonymsLocal: '',
    countryCode: 'MZ',
    currencyCode: 'MZN',
    officialLanguageCode: 'pt'
  },
  {
    countryNameLocal: 'Namibia',
    countrySynonymsLocal: '',
    countryCode: 'NA',
    currencyCode: 'NAD',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'Nouvelle-Calédonie',
    countrySynonymsLocal: '',
    countryCode: 'NC',
    currencyCode: 'XPF',
    officialLanguageCode: 'fr'
  },
  {
    countryNameLocal: 'Norfolk Island',
    countrySynonymsLocal: '',
    countryCode: 'NF',
    currencyCode: 'AUD',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'Nigeria',
    countrySynonymsLocal: '',
    countryCode: 'NG',
    currencyCode: 'NGN',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'Nicaragua',
    countrySynonymsLocal: '',
    countryCode: 'NI',
    currencyCode: 'NIO',
    officialLanguageCode: 'es',
    countryName: 'Nicaragua',
    phoneCode: '+505',
    flag: '🇳🇮',
    postalCode: { mask: '99999', placeholder: '12345', regex: /^\d{5}$/ },
    phoneFormat: {
      mask: '9999 9999',
      placeholder: '8123 4567',
      example: '+505 8123 4567'
    },
    vatFormat: {
      mask: '9999999999999999',
      placeholder: '1234567890123456',
      example: 'NI1234567890123456',
      regex: /^\d{16}$/
    }
  },
  {
    countryNameLocal: 'Norge, Noreg',
    countrySynonymsLocal: '',
    countryCode: 'NO',
    currencyCode: 'NOK',
    officialLanguageCode: 'nb'
  },
  {
    countryNameLocal: '',
    countrySynonymsLocal: '',
    countryCode: 'NP',
    currencyCode: 'NPR',
    officialLanguageCode: 'ne'
  },
  {
    countryNameLocal: 'Nauru',
    countrySynonymsLocal: '',
    countryCode: 'NR',
    currencyCode: 'AUD',
    officialLanguageCode: 'na'
  },
  {
    countryNameLocal: 'Niue',
    countrySynonymsLocal: '',
    countryCode: 'NU',
    currencyCode: 'NZD',
    officialLanguageCode: 'niu'
  },
  {
    countryNameLocal: 'New Zealand',
    countrySynonymsLocal: '',
    countryCode: 'NZ',
    currencyCode: 'NZD',
    officialLanguageCode: 'mi'
  },
  {
    countryNameLocal: 'سلطنة عُمان',
    countrySynonymsLocal: '',
    countryCode: 'OM',
    currencyCode: 'OMR',
    officialLanguageCode: 'ar'
  },
  {
    countryNameLocal: 'Panama',
    countrySynonymsLocal: '',
    countryCode: 'PA',
    currencyCode: 'PAB',
    officialLanguageCode: 'es'
  },
  {
    countryNameLocal: 'Perú',
    countrySynonymsLocal: '',
    countryCode: 'PE',
    currencyCode: 'PEN',
    officialLanguageCode: 'es'
  },
  {
    countryNameLocal: 'Polynésie française',
    countrySynonymsLocal: '',
    countryCode: 'PF',
    currencyCode: 'XPF',
    officialLanguageCode: 'fr'
  },
  {
    countryNameLocal: 'Papua New Guinea',
    countrySynonymsLocal: '',
    countryCode: 'PG',
    currencyCode: 'PGK',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'پاکستان',
    countrySynonymsLocal: '',
    countryCode: 'PK',
    currencyCode: 'PKR',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'Polska',
    countrySynonymsLocal: '',
    countryCode: 'PL',
    currencyCode: 'PLN',
    officialLanguageCode: 'pl',
    countryName: 'Polen',
    phoneCode: '+48',
    flag: '🇵🇱',
    postalCode: {
      mask: '99-999',
      placeholder: '00-950',
      regex: /^\d{2}-\d{3}$/
    },
    phoneFormat: {
      mask: '999 999 999',
      placeholder: '501 123 456',
      example: '+48 501 123 456'
    },
    vatFormat: {
      mask: '9999999999',
      placeholder: '1234567890',
      example: 'PL1234567890',
      regex: /^\d{10}$/
    }
  },
  {
    countryNameLocal: 'Saint-Pierre-et-Miquelon',
    countrySynonymsLocal: '',
    countryCode: 'PM',
    currencyCode: 'EUR',
    officialLanguageCode: 'fr'
  },
  {
    countryNameLocal: 'Pitcairn',
    countrySynonymsLocal: '',
    countryCode: 'PN',
    currencyCode: 'NZD',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'Puerto Rico',
    countrySynonymsLocal: '',
    countryCode: 'PR',
    currencyCode: 'USD',
    officialLanguageCode: 'es'
  },
  {
    countryNameLocal: 'Palestinian Territory',
    countrySynonymsLocal: '',
    countryCode: 'PS',
    currencyCode: '',
    officialLanguageCode: 'ar'
  },
  {
    countryNameLocal: 'Portugal',
    countrySynonymsLocal: '',
    countryCode: 'PT',
    currencyCode: 'EUR',
    officialLanguageCode: 'pt',
    postalCode: {
      mask: '9999-999',
      placeholder: '1000-001',
      regex: /^\d{4}-\d{3}$/
    }
  },
  {
    countryNameLocal: 'Palau',
    countrySynonymsLocal: '',
    countryCode: 'PW',
    currencyCode: 'USD',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'Paraguay',
    countrySynonymsLocal: '',
    countryCode: 'PY',
    currencyCode: 'PYG',
    officialLanguageCode: 'es'
  },
  {
    countryNameLocal: 'قطر',
    countrySynonymsLocal: '',
    countryCode: 'QA',
    currencyCode: 'QAR',
    officialLanguageCode: 'ar'
  },
  {
    countryNameLocal: 'La Réunion',
    countrySynonymsLocal: '',
    countryCode: 'RE',
    currencyCode: 'EUR',
    officialLanguageCode: 'fr'
  },
  {
    countryNameLocal: 'România',
    countrySynonymsLocal: '',
    countryCode: 'RO',
    currencyCode: 'RON',
    officialLanguageCode: 'ro',
    countryName: 'Rumänien',
    phoneCode: '+40',
    flag: '🇷🇴',
    postalCode: { mask: '999999', placeholder: '123456', regex: /^(\d{6})$/ },
    phoneFormat: {
      mask: '999 999 999',
      placeholder: '721 123 456',
      example: '+40 721 123 456'
    },
    vatFormat: {
      mask: '9999999999',
      placeholder: '1234567890',
      example: 'RO1234567890',
      regex: /^\d{2,10}$/
    }
  },
  {
    countryNameLocal: 'Србија',
    countrySynonymsLocal: '',
    countryCode: 'RS',
    currencyCode: 'RSD',
    officialLanguageCode: 'sr'
  },
  {
    countryNameLocal: 'Россия',
    countrySynonymsLocal: '',
    countryCode: 'RU',
    currencyCode: 'RUB',
    officialLanguageCode: 'ru'
  },
  {
    countryNameLocal: 'Rwanda',
    countrySynonymsLocal: '',
    countryCode: 'RW',
    currencyCode: 'RWF',
    officialLanguageCode: 'rw'
  },
  {
    countryNameLocal: 'السعودية',
    countrySynonymsLocal: '',
    countryCode: 'SA',
    currencyCode: 'SAR',
    officialLanguageCode: 'ar'
  },
  {
    countryNameLocal: 'Solomon Islands',
    countrySynonymsLocal: '',
    countryCode: 'SB',
    currencyCode: 'SBD',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'Seychelles',
    countrySynonymsLocal: '',
    countryCode: 'SC',
    currencyCode: 'SCR',
    officialLanguageCode: 'fr'
  },
  {
    countryNameLocal: 'Sverige',
    countrySynonymsLocal: '',
    countryCode: 'SE',
    currencyCode: 'SEK',
    officialLanguageCode: 'sv',
    countryName: 'Schweden',
    phoneCode: '+46',
    flag: '🇸🇪',
    postalCode: {
      mask: '999 99',
      placeholder: '702 36',
      regex: /^(\d{3} \d{2})$/
    },
    phoneFormat: {
      mask: '99 999 99 99',
      placeholder: '70 123 45 67',
      example: '+46 70 123 45 67'
    },
    vatFormat: {
      mask: '999999999999',
      placeholder: '123456789012',
      example: 'SE123456789012',
      regex: /^\d{12}$/
    }
  },
  {
    countryNameLocal: 'Singapore',
    countrySynonymsLocal: '',
    countryCode: 'SG',
    currencyCode: 'SGD',
    officialLanguageCode: 'zh-hans'
  },
  {
    countryNameLocal: 'Saint Helena',
    countrySynonymsLocal: '',
    countryCode: 'SH',
    currencyCode: 'SHP',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'Slovenija',
    countrySynonymsLocal: '',
    countryCode: 'SI',
    currencyCode: 'EUR',
    officialLanguageCode: 'sl',
    countryName: 'Slowenien',
    phoneCode: '+386',
    flag: '🇸🇮',
    postalCode: { mask: '9999', placeholder: '1234', regex: /^(\d{4})$/ },
    phoneFormat: {
      mask: '99 999 999',
      placeholder: '31 123 456',
      example: '+386 31 123 456'
    },
    vatFormat: {
      mask: '99999999',
      placeholder: '12345678',
      example: 'SI12345678',
      regex: /^\d{8}$/
    }
  },
  {
    countryNameLocal: 'Svalbard and Jan Mayen',
    countrySynonymsLocal: '',
    countryCode: 'SJ',
    currencyCode: 'NOK',
    officialLanguageCode: 'no'
  },
  {
    countryNameLocal: 'Slovensko',
    countrySynonymsLocal: '',
    countryCode: 'SK',
    currencyCode: 'EUR',
    officialLanguageCode: 'sk',
    countryName: 'Slowakei',
    phoneCode: '+421',
    flag: '🇸🇰',
    postalCode: {
      mask: '999 99',
      placeholder: '123 45',
      regex: /^(\d{3} \d{2})$/
    },
    phoneFormat: {
      mask: '999 999 999',
      placeholder: '901 123 456',
      example: '+421 901 123 456'
    },
    vatFormat: {
      mask: '9999999999',
      placeholder: '1234567890',
      example: 'SK1234567890',
      regex: /^\d{10}$/
    }
  },
  {
    countryNameLocal: 'Sierra Leone',
    countrySynonymsLocal: '',
    countryCode: 'SL',
    currencyCode: 'SLL',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'Repubblica di San Marino',
    countrySynonymsLocal: '',
    countryCode: 'SM',
    currencyCode: 'EUR',
    officialLanguageCode: 'it'
  },
  {
    countryNameLocal: 'Sénégal',
    countrySynonymsLocal: '',
    countryCode: 'SN',
    currencyCode: 'XOF',
    officialLanguageCode: 'fr'
  },
  {
    countryNameLocal: 'Somalia, الصومال',
    countrySynonymsLocal: '',
    countryCode: 'SO',
    currencyCode: 'SOS',
    officialLanguageCode: 'so',
    countryName: 'Somalia',
    phoneCode: '+252',
    flag: '🇸🇴',
    postalCode: {
      mask: 'aa 99999',
      placeholder: 'AB 12345',
      regex: /^[A-Z]{2} \d{5}$/
    },
    phoneFormat: {
      mask: '99 9999999',
      placeholder: '61 1234567',
      example: '+252 61 1234567'
    },
    vatFormat: {
      mask: '999999999',
      placeholder: '123456789',
      example: 'SO123456789',
      regex: /^\d{9}$/
    }
  },
  {
    countryNameLocal: 'Suriname',
    countrySynonymsLocal: '',
    countryCode: 'SR',
    currencyCode: 'SRD',
    officialLanguageCode: 'nl'
  },
  {
    countryNameLocal: 'South Sudan',
    countrySynonymsLocal: '',
    countryCode: 'SS',
    currencyCode: 'SSP',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'São Tomé e Príncipe',
    countrySynonymsLocal: '',
    countryCode: 'ST',
    currencyCode: 'STN',
    officialLanguageCode: 'pt'
  },
  {
    countryNameLocal: 'El Salvador',
    countrySynonymsLocal: '',
    countryCode: 'SV',
    currencyCode: 'SVC',
    officialLanguageCode: 'es'
  },
  {
    countryNameLocal: 'Sint Maarten',
    countrySynonymsLocal: '',
    countryCode: 'SX',
    currencyCode: 'ANG',
    officialLanguageCode: 'nl'
  },
  {
    countryNameLocal: 'سوريا, Sūriyya',
    countrySynonymsLocal: '',
    countryCode: 'SY',
    currencyCode: 'SYP',
    officialLanguageCode: 'ar'
  },
  {
    countryNameLocal: 'Tchad, تشاد',
    countrySynonymsLocal: '',
    countryCode: 'TD',
    currencyCode: 'XAF',
    officialLanguageCode: 'fr'
  },
  {
    countryNameLocal: 'Togo',
    countrySynonymsLocal: '',
    countryCode: 'TG',
    currencyCode: 'XOF',
    officialLanguageCode: 'fr'
  },
  {
    countryNameLocal: 'ประเทศไทย',
    countrySynonymsLocal: '',
    countryCode: 'TH',
    currencyCode: 'THB',
    officialLanguageCode: 'th'
  },
  {
    countryNameLocal: ',',
    countrySynonymsLocal: '',
    countryCode: 'TJ',
    currencyCode: 'TJS',
    officialLanguageCode: 'tg'
  },
  {
    countryNameLocal: 'Tokelau',
    countrySynonymsLocal: '',
    countryCode: 'TK',
    currencyCode: 'NZD',
    officialLanguageCode: 'tkl'
  },
  {
    countryNameLocal: "Timor-Leste, Timor Lorosa'e",
    countrySynonymsLocal: '',
    countryCode: 'TL',
    currencyCode: 'USD',
    officialLanguageCode: 'pt'
  },
  {
    countryNameLocal: 'Türkmenistan',
    countrySynonymsLocal: '',
    countryCode: 'TM',
    currencyCode: 'TMT',
    officialLanguageCode: 'tk'
  },
  {
    countryNameLocal: 'تونس, Tunisie',
    countrySynonymsLocal: '',
    countryCode: 'TN',
    currencyCode: 'TND',
    officialLanguageCode: 'ar'
  },
  {
    countryNameLocal: 'Tonga',
    countrySynonymsLocal: '',
    countryCode: 'TO',
    currencyCode: 'TOP',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'Türkiye',
    countrySynonymsLocal: '',
    countryCode: 'TR',
    currencyCode: 'TRY',
    officialLanguageCode: 'tr'
  },
  {
    countryNameLocal: 'Trinidad and Tobago',
    countrySynonymsLocal: '',
    countryCode: 'TT',
    currencyCode: 'TTD',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'Tuvalu',
    countrySynonymsLocal: '',
    countryCode: 'TV',
    currencyCode: 'AUD',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'Tanzania',
    countrySynonymsLocal: '',
    countryCode: 'TZ',
    currencyCode: 'TZS',
    officialLanguageCode: 'sw'
  },
  {
    countryNameLocal: 'Україна',
    countrySynonymsLocal: '',
    countryCode: 'UA',
    currencyCode: 'UAH',
    officialLanguageCode: 'uk'
  },
  {
    countryNameLocal: 'Uganda',
    countrySynonymsLocal: '',
    countryCode: 'UG',
    currencyCode: 'UGX',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'United States of America',
    countrySynonymsLocal: 'USA Amerika America',
    countryCode: 'US',
    currencyCode: 'USD',
    officialLanguageCode: 'en',
    countryName: 'USA',
    phoneCode: '+1',
    flag: '🇺🇸',
    postalCode: { mask: '99999', placeholder: '12345', regex: /^\d{5}$/ },
    phoneFormat: {
      mask: '(999) 999-9999',
      placeholder: '(555) 123-4567',
      example: '+1 (555) 123-4567'
    },
    vatFormat: {
      mask: '99-9999999',
      placeholder: '12-3456789',
      example: 'US12-3456789',
      regex: /^\d{2}-\d{7}$/
    }
  },
  {
    countryNameLocal: 'Uruguay',
    countrySynonymsLocal: '',
    countryCode: 'UY',
    currencyCode: 'UYU',
    officialLanguageCode: 'es'
  },
  {
    countryNameLocal: '',
    countrySynonymsLocal: '',
    countryCode: 'UZ',
    currencyCode: 'UZS',
    officialLanguageCode: 'uz'
  },
  {
    countryNameLocal: 'Saint Vincent and the Grenadines',
    countrySynonymsLocal: '',
    countryCode: 'VC',
    currencyCode: 'XCD',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'Venezuela',
    countrySynonymsLocal: '',
    countryCode: 'VE',
    currencyCode: 'VES',
    officialLanguageCode: 'es'
  },
  {
    countryNameLocal: 'British Virgin Islands',
    countrySynonymsLocal: '',
    countryCode: 'VG',
    currencyCode: 'USD',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'United States Virgin Islands',
    countrySynonymsLocal: '',
    countryCode: 'VI',
    currencyCode: 'USD',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'Việt Nam',
    countrySynonymsLocal: '',
    countryCode: 'VN',
    currencyCode: 'VND',
    officialLanguageCode: 'vi'
  },
  {
    countryNameLocal: 'Vanuatu',
    countrySynonymsLocal: '',
    countryCode: 'VU',
    currencyCode: 'VUV',
    officialLanguageCode: 'bi'
  },
  {
    countryNameLocal: 'Wallis-et-Futuna',
    countrySynonymsLocal: '',
    countryCode: 'WF',
    currencyCode: 'XPF',
    officialLanguageCode: 'fr'
  },
  {
    countryNameLocal: 'Samoa',
    countrySynonymsLocal: '',
    countryCode: 'WS',
    currencyCode: 'WST',
    officialLanguageCode: 'sm'
  },
  {
    countryNameLocal: 'اليَمَن',
    countrySynonymsLocal: '',
    countryCode: 'YE',
    currencyCode: 'YER',
    officialLanguageCode: 'ar'
  },
  {
    countryNameLocal: 'Mayotte',
    countrySynonymsLocal: '',
    countryCode: 'YT',
    currencyCode: 'EUR',
    officialLanguageCode: 'fr'
  },
  {
    countryNameLocal: 'South Africa',
    countrySynonymsLocal: '',
    countryCode: 'ZA',
    currencyCode: 'ZAR',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'Zambia',
    countrySynonymsLocal: '',
    countryCode: 'ZM',
    currencyCode: 'ZMW',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'Zimbabwe',
    countrySynonymsLocal: '',
    countryCode: 'ZW',
    currencyCode: 'ZWL',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'Swaziland',
    countrySynonymsLocal: '',
    countryCode: 'SZ',
    currencyCode: 'SZL',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'Македонија',
    countrySynonymsLocal: '',
    countryCode: 'MK',
    currencyCode: 'MKD',
    officialLanguageCode: 'mk'
  },
  {
    countryNameLocal: 'Philippines',
    countrySynonymsLocal: '',
    countryCode: 'PH',
    currencyCode: 'PHP',
    officialLanguageCode: 'en',
    countryName: 'Philippinen',
    phoneCode: '+63',
    flag: '🇵🇭',
    postalCode: { mask: '9999', placeholder: '1234', regex: /^\d{4}$/ },
    phoneFormat: {
      mask: '999 999 9999',
      placeholder: '917 123 4567',
      example: '+63 917 123 4567'
    },
    vatFormat: {
      mask: '999-999-999-99999',
      placeholder: '123-456-789-01234',
      example: 'PH123-456-789-01234',
      regex: /^\d{3}-\d{3}-\d{3}-\d{5}$/
    }
  },
  {
    countryNameLocal: 'Nederland',
    countrySynonymsLocal: '',
    countryCode: 'NL',
    currencyCode: 'EUR',
    officialLanguageCode: 'nl',
    countryName: 'Niederlande',
    phoneCode: '+31',
    flag: '🇳🇱',
    postalCode: {
      mask: '9999 aa',
      placeholder: '1234 AB',
      regex: /^[0-9]{4} [A-Z]{2}$/
    },
    phoneFormat: {
      mask: '9 99999999',
      placeholder: '6 12345678',
      example: '+31 6 12345678'
    },
    vatFormat: {
      mask: 'aa999999999*99',
      placeholder: 'NL123456789B01',
      example: 'NL123456789B01',
      regex: /^NL\d{9}[A-Z]\d{2}$/
    }
  },
  {
    countryNameLocal: 'دولة الإمارات العربيّة المتّحدة',
    countrySynonymsLocal: '',
    countryCode: 'AE',
    currencyCode: 'AED',
    officialLanguageCode: 'ar'
  },
  {
    countryNameLocal: 'Moldova, Молдавия',
    countrySynonymsLocal: '',
    countryCode: 'MD',
    currencyCode: 'MDL',
    officialLanguageCode: 'ro'
  },
  {
    countryNameLocal: 'The Gambia',
    countrySynonymsLocal: '',
    countryCode: 'GM',
    currencyCode: 'GMD',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'República Dominicana',
    countrySynonymsLocal: '',
    countryCode: 'DO',
    currencyCode: 'DOP',
    officialLanguageCode: 'es'
  },
  {
    countryNameLocal: 'السودان',
    countrySynonymsLocal: '',
    countryCode: 'SD',
    currencyCode: 'SDG',
    officialLanguageCode: 'ar'
  },
  {
    countryNameLocal: 'ປະຊາຊົນລາວ',
    countrySynonymsLocal: '',
    countryCode: 'LA',
    currencyCode: 'LAK',
    officialLanguageCode: 'lo'
  },
  {
    countryNameLocal: 'Taiwan',
    countrySynonymsLocal: '',
    countryCode: 'TW',
    currencyCode: 'TWD',
    officialLanguageCode: 'zh-hant'
  },
  {
    countryNameLocal: 'République du Congo',
    countrySynonymsLocal: '',
    countryCode: 'CG',
    currencyCode: 'XAF',
    officialLanguageCode: 'fr'
  },
  {
    countryNameLocal: 'Česká republika',
    countrySynonymsLocal: '',
    countryCode: 'CZ',
    currencyCode: 'CZK',
    officialLanguageCode: 'cs',
    countryName: 'Tschechien',
    phoneCode: '+420',
    flag: '🇨🇿',
    postalCode: {
      mask: '999 99',
      placeholder: '123 45',
      regex: /^(\d{3} \d{2})$/
    },
    phoneFormat: {
      mask: '999 999 999',
      placeholder: '601 123 456',
      example: '+420 601 123 456'
    },
    vatFormat: {
      mask: '9999999999',
      placeholder: '12345678',
      example: 'CZ12345678',
      regex: /^\d{8,10}$/
    }
  },
  {
    countryNameLocal: 'Great Britain',
    countrySynonymsLocal: 'UK England GB',
    countryCode: 'GB',
    currencyCode: 'GBP',
    officialLanguageCode: 'en',
    countryName: 'Vereinigtes Königreich',
    phoneCode: '+44',
    flag: '🇬🇧',
    postalCode: {
      mask: 'a*9 9**',
      placeholder: 'SW1A 1AA',
      regex:
        /^([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9][A-Za-z]?))))\s?[0-9][A-Za-z]{2})$/
    },
    phoneFormat: {
      mask: '9999 999999',
      placeholder: '7123 456789',
      example: '+44 7123 456789'
    },
    vatFormat: {
      mask: 'aa999999999',
      placeholder: 'GB123456789',
      example: 'GB123456789',
      regex: /^GB\d{9}$/
    }
  },
  {
    countryNameLocal: 'Niger',
    countrySynonymsLocal: '',
    countryCode: 'NE',
    currencyCode: 'XOF',
    officialLanguageCode: 'fr'
  },
  {
    countryNameLocal: 'Democratic Republic of the Congo',
    countrySynonymsLocal: '',
    countryCode: 'CD',
    currencyCode: 'CDF',
    officialLanguageCode: 'fr'
  },
  {
    countryNameLocal: 'Commonwealth of The Bahamas',
    countrySynonymsLocal: '',
    countryCode: 'BS',
    currencyCode: 'BSD',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'Pulu Kokos (Keeling)',
    countrySynonymsLocal: '',
    countryCode: 'CC',
    currencyCode: 'AUD',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'République centrafricaine',
    countrySynonymsLocal: '',
    countryCode: 'CF',
    currencyCode: 'XAF',
    officialLanguageCode: 'fr'
  },
  {
    countryNameLocal: "Kūki 'Āirani",
    countrySynonymsLocal: '',
    countryCode: 'CK',
    currencyCode: 'NZD',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'Falkland Islands',
    countrySynonymsLocal: '',
    countryCode: 'FK',
    currencyCode: 'FKP',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'Færøerne',
    countrySynonymsLocal: '',
    countryCode: 'FO',
    currencyCode: 'DKK',
    officialLanguageCode: 'da'
  },
  {
    countryNameLocal: 'Territory of Heard Island and McDonald Islands',
    countrySynonymsLocal: '',
    countryCode: 'HM',
    currencyCode: 'AUD',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'British Indian Ocean Territory',
    countrySynonymsLocal: '',
    countryCode: 'IO',
    currencyCode: 'USD',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'Umoja wa Komori',
    countrySynonymsLocal: '',
    countryCode: 'KM',
    currencyCode: 'KMF',
    officialLanguageCode: 'fr'
  },
  {
    countryNameLocal: 'Cayman Islands',
    countrySynonymsLocal: '',
    countryCode: 'KY',
    currencyCode: 'KYD',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'Aolepān Aorōkin Ṃajeḷ',
    countrySynonymsLocal: '',
    countryCode: 'MH',
    currencyCode: 'USD',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'Sankattan Siha Na Islas Mariånas',
    countrySynonymsLocal: '',
    countryCode: 'MP',
    currencyCode: 'USD',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'Turks and Caicos Islands',
    countrySynonymsLocal: '',
    countryCode: 'TC',
    currencyCode: 'USD',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'Terres australes et antarctiques françaises',
    countrySynonymsLocal: '',
    countryCode: 'TF',
    currencyCode: 'EUR',
    officialLanguageCode: 'fr'
  },
  {
    countryNameLocal: 'United States Minor Outlying Islands',
    countrySynonymsLocal: '',
    countryCode: 'UM',
    currencyCode: 'USD',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'Sancta Sedes',
    countrySynonymsLocal: '',
    countryCode: 'VA',
    currencyCode: 'EUR',
    officialLanguageCode: 'la'
  },
  {
    countryNameLocal: 'Republika e Kosovës',
    countrySynonymsLocal: '',
    countryCode: 'XK',
    currencyCode: 'EUR',
    officialLanguageCode: 'sq'
  },
  {
    countryNameLocal: 'Nederlandse Antillen',
    countrySynonymsLocal: '',
    countryCode: 'AN',
    currencyCode: 'ANG',
    officialLanguageCode: 'nl'
  }
] as const;

/**
 * Erweiterte Länderkonfiguration mit PLZ-Formatierung, Telefon-Vorwahlen, VAT-Nummern und Flaggen
 *
 * Struktur:
 * - code: ISO 3166-1 Alpha-2 Ländercode
 * - name: Deutscher Ländername
 * - nameLocal: Lokaler Ländername
 * - phoneCode: Internationale Telefon-Vorwahl (ITU-T E.164)
 * - flag: Unicode Flag Emoji für bessere UX
 * - postalCode: PLZ-Formatierungsregeln
 *   - mask: PrimeVue InputMask Pattern (9=Ziffer, a=Buchstabe)
 *   - placeholder: Beispiel für das erwartete Format
 *   - regex: RegEx für Validierung (optional)
 * - phoneFormat: Telefonnummer-Formatierung
 *   - mask: InputMask für lokale Telefonnummern
 *   - placeholder: Beispiel für nationales Format
 *   - example: Beispiel einer vollständigen internationalen Nummer
 * - vatFormat: VAT/USt-IdNr-Formatierung
 *   - mask: InputMask für Umsatzsteuer-Identifikationsnummer
 *   - placeholder: Beispiel für das erwartete Format
 *   - example: Vollständige VAT-Nummer mit Ländercode
 *   - regex: RegEx für Validierung (optional)
 *
 * Quellen:
 * - PLZ: https://bpost.freshdesk.com/support/solutions/articles/4000040467-international-zip-code-masks-for-seamless-shipping-with-bpost
 * - Telefon: https://www.npmjs.com/package/country-codes-list
 * - ITU-T E.164: https://www.itu.int/rec/T-REC-E.164/
 * - VAT: https://avalara.com/vatlive/en/eu-vat-rules/eu-vat-number-registration/eu-vat-number-formats.html
 */

/**
 * Hilfsfunktionen für die Länderverarbeitung
 */

// Erstellt eine Map von Ländercode zu PLZ-Pattern
export const getPostalCodePatterns = () => {
  const patterns: Record<
    string,
    { mask: string; placeholder: string; regex: RegExp }
  > = {};
  countries.forEach((country) => {
    if (country.postalCode) {
      patterns[country.countryCode] = country.postalCode;
    }
  });
  return patterns;
};

// Erstellt eine Map von Ländercode zu Phone-Pattern
export const getPhonePatterns = () => {
  const patterns: Record<
    string,
    {
      code: string;
      flag: string;
      format: {
        mask: string;
        placeholder: string;
        regex?: RegExp;
        example: string;
      };
    }
  > = {};
  countries.forEach((country) => {
    if (country.phoneCode && country.flag && country.phoneFormat) {
      patterns[country.countryCode] = {
        code: country.phoneCode,
        flag: country.flag,
        format: country.phoneFormat
      };
    }
  });
  return patterns;
};

// Erstellt eine Map von Ländercode zu VAT-Pattern
export const getVatPatterns = () => {
  const patterns: Record<string, {}> = {};
  countries.forEach((country) => {
    if (country.vatFormat) {
      patterns[country.countryCode] = country.vatFormat;
    }
  });
  return patterns;
};

// Findet ein Land anhand des Codes
export const getCountryByCode = (code: string) => {
  return countries.find((country) => country.countryCode === code);
};

// Gibt alle verfügbaren Ländercodes zurück
export const getCountryCodes = () => {
  return countries.map((country) => country.countryCode);
};

// Erstellt eine sortierte Liste nach Namen
export const getCountriesSortedByName = () => {
  return [...countries].sort((a, b) =>
    a.countryNameLocal.localeCompare(b.countryNameLocal, 'de')
  );
};

// Validiert eine PLZ für ein bestimmtes Land
export const validatePostalCode = (
  postalCode: string,
  countryCode: string,
  dictionary?: Record<string, string>
) => {
  if (!postalCode || !countryCode) {
    return {
      isValid: false,
      message:
        dictionary?.['validation.postalCode.required'] ??
        'Postal code and country code are required'
    };
  }

  const country = getCountryByCode(countryCode);
  if (!country) {
    return {
      isValid: false,
      message: dictionary?.['validation.country.unknown'] ?? 'Unknown country'
    };
  }

  const { regex, placeholder } = country.postalCode ?? {};
  if (!regex) {
    return {
      isValid: true,
      message:
        dictionary?.['validation.postalCode.noValidation'] ??
        'No validation available'
    };
  }

  const isValid = regex.test(postalCode);
  return {
    isValid,
    message: isValid
      ? dictionary?.['validation.postalCode.valid'] ?? 'Postal code is valid'
      : dictionary?.['validation.postalCode.invalidFormat']
      ? dictionary['validation.postalCode.invalidFormat'].replace(
          '{placeholder}',
          placeholder ?? ''
        )
      : `Postal code does not match the expected format: ${placeholder}`
  };
};

// Validiert eine Telefonnummer für ein bestimmtes Land
export const validatePhoneNumber = (
  phoneNumber: string,
  countryCode: string,
  dictionary?: Record<string, string>
) => {
  if (!phoneNumber || !countryCode) {
    return {
      isValid: false,
      message:
        dictionary?.['validation.phoneNumber.required'] ??
        'Phone number and country code are required'
    };
  }

  const country = getCountryByCode(countryCode);
  if (!country) {
    return {
      isValid: false,
      message: dictionary?.['validation.country.unknown'] ?? 'Unknown country'
    };
  }

  // Bereinige Telefonnummer: nur Ziffern und Leerzeichen
  const cleanNumber = phoneNumber.replace(/[^\d\s]/g, '');

  // Prüfe ob länderspezifische Regex vorhanden ist
  if (country.phoneFormat?.regex) {
    const isValid = country.phoneFormat.regex.test(cleanNumber);
    const countryName = country.countryName ?? country.countryNameLocal;
    return {
      isValid,
      message: isValid
        ? dictionary?.['validation.phoneNumber.valid'] ??
          'Phone number is valid'
        : dictionary?.['validation.phoneNumber.invalidFormat']
        ? dictionary['validation.phoneNumber.invalidFormat']
            .replace('{countryName}', countryName)
            .replace('{example}', country.phoneFormat.example)
        : `Invalid format for ${countryName}. Example: ${country.phoneFormat.example}`
    };
  }

  // Fallback: Grundlegende Validierung (7-15 Ziffern)
  const digitsOnly = cleanNumber.replace(/\D/g, '');
  const isValid = digitsOnly.length >= 7 && digitsOnly.length <= 15;

  return {
    isValid,
    message: isValid
      ? dictionary?.['validation.phoneNumber.valid'] ?? 'Phone number is valid'
      : dictionary?.['validation.phoneNumber.invalidLength']
      ? dictionary['validation.phoneNumber.invalidLength'].replace(
          '{example}',
          country.phoneFormat?.example ?? ''
        )
      : `Phone number should have between 7 and 15 digits (Format: ${country.phoneFormat?.example})`
  };
};

// Formatiert eine internationale Telefonnummer
export const formatInternationalPhone = (
  localNumber: string,
  countryCode: string
) => {
  if (!localNumber || !countryCode) {
    return localNumber;
  }

  const country = getCountryByCode(countryCode);
  if (!country) {
    return localNumber;
  }

  // Entferne alle nicht-numerischen Zeichen außer +
  const cleanNumber = localNumber.replace(/[^\d+]/g, '');

  // Wenn bereits internationale Nummer (beginnt mit +), gib sie zurück
  if (cleanNumber.startsWith('+')) {
    return cleanNumber;
  }

  // Entferne führende 0 falls vorhanden (typisch für nationale Nummern)
  const withoutLeadingZero = cleanNumber.startsWith('0')
    ? cleanNumber.substring(1)
    : cleanNumber;

  return `${country.phoneCode} ${withoutLeadingZero}`;
};

// Validiert eine VAT-Nummer für ein bestimmtes Land
export const validateVatNumber = (
  vatNumber: string,
  countryCode: string,
  dictionary?: Record<string, string>
) => {
  if (!vatNumber || !countryCode) {
    return {
      isValid: false,
      message:
        dictionary?.['validation.vatNumber.required'] ??
        'VAT number and country code are required'
    };
  }

  const country = getCountryByCode(countryCode);
  if (!country) {
    return {
      isValid: false,
      message: dictionary?.['validation.country.unknown'] ?? 'Unknown country'
    };
  }

  if (!country.vatFormat) {
    return {
      isValid: true,
      message:
        dictionary?.['validation.vatNumber.noValidationForCountry'] ??
        'No VAT validation available for this country'
    };
  }

  const { regex, placeholder } = country.vatFormat;
  if (!regex) {
    return {
      isValid: true,
      message:
        dictionary?.['validation.vatNumber.noValidation'] ??
        'No VAT validation available'
    };
  }

  const isValid = regex.test(vatNumber);
  return {
    isValid,
    message: isValid
      ? dictionary?.['validation.vatNumber.valid'] ?? 'VAT number is valid'
      : dictionary?.['validation.vatNumber.invalidFormat']
      ? dictionary['validation.vatNumber.invalidFormat'].replace(
          '{placeholder}',
          placeholder ?? ''
        )
      : `VAT number does not match the expected format: ${placeholder}`
  };
};

// Formatiert eine VAT-Nummer mit Ländercode
export const formatInternationalVat = (
  localVatNumber: string,
  countryCode: string
) => {
  if (!localVatNumber || !countryCode) {
    return localVatNumber;
  }

  const country = getCountryByCode(countryCode);
  if (!country || !country.vatFormat) {
    return localVatNumber;
  }

  // Entferne Ländercode falls bereits vorhanden
  const cleanVat = localVatNumber
    .replace(new RegExp(`^${countryCode}`, 'i'), '')
    .trim();

  // Wenn bereits vollständige VAT-Nummer (beginnt mit Ländercode), gib sie zurück
  if (localVatNumber.toUpperCase().startsWith(countryCode)) {
    return localVatNumber.toUpperCase();
  }

  return `${countryCode}${cleanVat}`;
};

// Erstellt eine Übersicht aller PLZ-Formate für Debugging
export const getPostalCodeFormats = () => {
  return countries.map((country) => ({
    code: country.countryCode,
    name: country.countryName ?? country.countryNameLocal,
    mask: country.postalCode?.mask,
    placeholder: country.postalCode?.placeholder,
    hasRegex: !!country.postalCode?.regex
  }));
};

// Erstellt eine Übersicht aller Telefon-Formate für Debugging
export const getPhoneFormats = () => {
  return countries.map((country) => ({
    code: country.countryCode,
    name: country.countryName ?? country.countryNameLocal,
    phoneCode: country.phoneCode,
    mask: country.phoneFormat?.mask,
    placeholder: country.phoneFormat?.placeholder,
    example: country.phoneFormat?.example
  }));
};

// Erstellt eine Übersicht aller VAT-Formate für Debugging
export const getVatFormats = () => {
  return countries
    .filter((country) => country.vatFormat)
    .map((country) => ({
      code: country.countryCode,
      name: country.countryName ?? country.countryNameLocal,
      mask: country.vatFormat?.mask,
      placeholder: country.vatFormat?.placeholder,
      example: country.vatFormat?.example,
      hasRegex: !!country.vatFormat?.regex
    }));
};
